/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanyMetadataDto
 */
export interface CompanyMetadataDto {
    /**
     * 
     * @type {string}
     * @memberof CompanyMetadataDto
     */
    name: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyMetadataDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyMetadataDto
     */
    totalOrderAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyMetadataDto
     */
    totalOrderCount?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyMetadataDto
     */
    rank?: number;
}

/**
 * Check if a given object implements the CompanyMetadataDto interface.
 */
export function instanceOfCompanyMetadataDto(value: object): value is CompanyMetadataDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CompanyMetadataDtoFromJSON(json: any): CompanyMetadataDto {
    return CompanyMetadataDtoFromJSONTyped(json, false);
}

export function CompanyMetadataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyMetadataDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'totalOrderAmount': json['totalOrderAmount'] == null ? undefined : json['totalOrderAmount'],
        'totalOrderCount': json['totalOrderCount'] == null ? undefined : json['totalOrderCount'],
        'rank': json['rank'] == null ? undefined : json['rank'],
    };
}

export function CompanyMetadataDtoToJSON(json: any): CompanyMetadataDto {
    return CompanyMetadataDtoToJSONTyped(json, false);
}

export function CompanyMetadataDtoToJSONTyped(value?: CompanyMetadataDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'totalOrderAmount': value['totalOrderAmount'],
        'totalOrderCount': value['totalOrderCount'],
        'rank': value['rank'],
    };
}

